import createIcon from '../../createIcon';

/**
 * @component @name Aod
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTcgMS4wMUw3IDFDNS45IDEgNSAxLjkgNSAzVjIxQzUgMjIuMSA1LjkgMjMgNyAyM0gxN0MxOC4xIDIzIDE5IDIyLjEgMTkgMjFWM0MxOSAxLjkgMTguMSAxLjAxIDE3IDEuMDFaTTE3IDE4SDdWNkgxN1YxOFpNOCAxMEgxNlYxMS41SDhWMTBaTTkgMTNIMTVWMTQuNUg5VjEzWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Aod = createIcon('Aod', [
  [
    'path',
    {
      d: 'M17 1.01L7 1C5.9 1 5 1.9 5 3V21C5 22.1 5.9 23 7 23H17C18.1 23 19 22.1 19 21V3C19 1.9 18.1 1.01 17 1.01ZM17 18H7V6H17V18ZM8 10H16V11.5H8V10ZM9 13H15V14.5H9V13Z',
      key: '1a7d3g',
    },
  ],
]);

export default Aod;
